import {
  LOGIN,
  LOGOUT,
  REGISTER,
  SET_EMAIL,
  SET_INITIALIZED,
  SET_LOADING,
  SET_ERROR,
} from "./actions";
import { normalizeAuthUser } from "utils/adminAccess";

export const initialState = {
  isLoggedIn: false,
  isInitialized: false,
  isLoading: false,
  user: null,
  email: null,
  error: null,
};

const auth = (state = initialState, action) => {
  try {
    switch (action.type) {
      case REGISTER: {
        const { user } = action.payload;
        return {
          ...state,
          user: normalizeAuthUser(user),
        };
      }
      case LOGIN: {
        const { user } = action.payload;
        return {
          ...state,
          isLoggedIn: true,
          isInitialized: true,
          user: normalizeAuthUser(user),
          error: null,
        };
      }
      case LOGOUT: {
        return {
          ...initialState,
          isInitialized: true,
        };
      }
      case SET_INITIALIZED: {
        return {
          ...state,
          isInitialized: true,
        };
      }
      case SET_EMAIL: {
        const { email } = action.payload;
        return {
          ...state,
          email,
        };
      }
      case SET_LOADING: {
        return {
          ...state,
          isLoading: action.payload,
        };
      }
      case SET_ERROR: {
        return {
          ...state,
          error: action.payload,
          isLoading: false,
        };
      }
      default: {
        return state;
      }
    }
  } catch (error) {
    console.error(`Error in auth reducer from ${action.type}:`, error);
    return {
      ...state,
      error: error.message,
      isLoading: false,
    };
  }
};

// Selectors
// SEC-019: there's no accessToken in this slice anymore — the cookie is
// httpOnly, so JS can't read it and has no reason to need to. isLoggedIn
// alone is what the rest of the app actually checks "am I authenticated"
// against; the cookie is what the browser sends automatically.
export const selectIsAuthenticated = (state) => state.auth.isLoggedIn;
export const selectUser = (state) => state.auth.user;
export const selectIsInitialized = (state) => state.auth.isInitialized;
export const selectError = (state) => state.auth.error;
export const selectIsLoading = (state) => state.auth.isLoading;
export const selectEmail = (state) => state.auth.email;

export default auth;
